import { GsShield } from "./GsShield";

export const Footer = () => {
  return (
    <footer className="bg-charcoal text-warm-white/65 border-t border-warm-white/10">
      <div className="container-tight py-14 grid gap-10 md:grid-cols-12">
        <div className="md:col-span-5">
          <div className="flex items-center gap-3">
            <GsShield className="h-10 w-auto" />
            <div>
              <div className="font-display text-lg tracking-wide text-warm-white uppercase">
                Golden State <span className="text-brass">Project Works</span>
              </div>
              <div className="text-[10px] uppercase tracking-[0.3em] text-warm-white/75 mt-0.5">
                Built by Apache
              </div>
            </div>
          </div>
          <p className="mt-5 max-w-sm text-sm leading-relaxed">
            Same-day junk removal, debris cleanup, and handyman work for homeowners and property
            owners across Los Angeles.
          </p>
        </div>
        <div className="md:col-span-3">
          <div className="text-[10px] uppercase tracking-[0.25em] text-warm-white/75 mb-4">
            Explore
          </div>
          <ul className="space-y-2 text-sm">
            {[
              ["#services", "Services"],
              ["#projects", "Work"],
              ["#about", "About"],
              ["#reviews", "Reviews"],
            ].map(([h, l]) => (
              <li key={h}>
                <a href={h} className="hover:text-brass transition-colors">
                  {l}
                </a>
              </li>
            ))}
          </ul>
        </div>
        <div className="md:col-span-4">
          <div className="text-[10px] uppercase tracking-[0.25em] text-warm-white/75 mb-4">
            Contact
          </div>
          <ul className="space-y-2 text-sm">
            <li>
              <a href="tel:+12139866277" className="hover:text-brass">
                (213) 986-6277
              </a>
            </li>
            <li>Los Angeles · Greater LA County</li>
          </ul>
        </div>
      </div>
      <div className="border-t border-warm-white/10">
        <div className="container-tight py-6 flex flex-wrap items-center justify-between gap-3 text-xs text-warm-white/70">
          <div>© {new Date().getFullYear()} Golden State Project Works. All rights reserved.</div>
          <div>Honest scopes. Clean job sites. Quality work that lasts.</div>
        </div>
      </div>
    </footer>
  );
};
